@if (ga()) {
  <div class="mobi-ui-padding-y-lg">
    <mobi-ui-contact-person-major
      class="mobi-ui-ink-black"
      [mapLocations]="[
        {
          address: ga().addressStreet + ', ' + ga().addressZipCity,
        },
      ]"
      [imgTopOffset]="false"
      [imgSrc]="imageUrl()"
      [loadMap]="!showConsentPlaceholder()"
    >
      <span class="mobi-ui-font-h6">{{
        'gabox_lead' | texts: { context: 'primcalc', default: 'Ihre Ansprechsperson' }
      }}</span>
      <span class="mobi-ui-font-h3 !p-0 mobi-ui-ink-default">
        {{ ga().generalAgentName }}
      </span>
      <span
        class="mobi-ui-font-tisa mobi-ui-font-italic mobi-ui-margin-b-xl lg:!mb-0 block mobi-ui-ink-default"
      >
        {{ ga().addressName }}
      </span>
      <a
        class="mobi-ui-card-major mobi-ui-margin-t-md mobi-ui-text-break"
        [attr.data-tracking]="
          {
            tealium_event: 'contact_request',
            contact_type: 'address',
            agency_name: ga().addressName,
          } | json
        "
      >
        <div class="mobi-ui-text-block-major is-small">
          <mobi-ui-icon-major name="location_pin" class="md" />
          <div class="mobi-ui-text-block-content-major">
            <span class="mobi-ui-text-block-label-major">
              {{ 'address' | texts: { context: 'frontend', default: 'Adresse' } }}
            </span>
            <span class="mobi-ui-text-block-content">{{ ga().addressStreet }}</span>
            <span class="mobi-ui-text-block-content-major">
              {{ ga().addressZipCity }}
            </span>
          </div>
        </div>
      </a>
      <a
        [href]="'tel:' + ga().phone"
        class="mobi-ui-card-major mobi-ui-text-break mobi-ui-ink-default"
        [attr.data-tracking]="
          {
            tealium_event: 'contact_request',
            contact_type: 'phone',
            agency_name: ga().addressName,
          } | json
        "
      >
        <div class="mobi-ui-text-block-major is-small">
          <mobi-ui-icon-major name="phone" class="md" />
          <div class="mobi-ui-text-block-content-major">
            <span class="mobi-ui-text-block-label-major">
              {{ 'phone' | texts: { context: 'frontend', default: 'Telefon' } }}
            </span>
            <span class="mobi-ui-text-block-content-major">{{ ga().phone }}</span>
          </div>
        </div>
      </a>
      <a
        [href]="'mailto:' + ga().email"
        class="mobi-ui-card-major mobi-ui-text-break mobi-ui-ink-default"
        [attr.data-tracking]="
          {
            tealium_event: 'contact_request',
            contact_type: 'email',
            agency_name: ga().addressName,
          } | json
        "
      >
        <div class="mobi-ui-text-block-major">
          <mobi-ui-icon-major name="mail_electronic" class="md" />
          <div class="mobi-ui-text-block-content-major">
            <span class="mobi-ui-text-block-label-major">
              {{ 'email' | texts: { context: 'frontend', default: 'Email' } }}
            </span>
            <span class="mobi-ui-text-block-content-major mobi-ui-text-truncate">
              {{ ga().email }}
            </span>
          </div>
        </div>
      </a>
      <mobi-ui-contact-person-map-placeholder-major>
        <mobi-cookie-consent-overlay class="h-full block" />
      </mobi-ui-contact-person-map-placeholder-major>
    </mobi-ui-contact-person-major>
  </div>
}
